module.exports = __webpack_public_path__ + "static/2roboti_sq-e222176d7794d402a736e9094fe0cb72.jpg";